export default __webpack_public_path__ + "img/cLcrfmyu.28fd4d80.svg";